import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {AuthService} from '../../../../core/ngrx/main/auth.service';

@Component({
    selector: 'kt-codepin',
    templateUrl: './codepin.component.html',
    styleUrls: ['./codepin.component.scss']
})
export class CodepinComponent implements OnInit, OnChanges {

    @Input('email') email: string = '';
    @Input('debloquerRetour') debloquerRetour: string = '';
    @Input('loading') loading: boolean = false;
    @Output('debloquer') debloquer = new EventEmitter<string>();

    notValide: boolean = true;
    pinEnvoye: any = {};
    pinLoading: boolean = false;


    @ViewChild('pin1') pin1: ElementRef;
    @ViewChild('pin2') pin2: ElementRef;
    @ViewChild('pin3') pin3: ElementRef;
    @ViewChild('pin4') pin4: ElementRef;
    @ViewChild('pin5') pin5: ElementRef;
    @ViewChild('pin6') pin6: ElementRef;
    @ViewChild('btn') btn: ElementRef;

    constructor(
        private authService: AuthService,
        private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(): void {
        if (this.debloquerRetour == '0') {
            this.pin1.nativeElement.value = '';
            this.pin2.nativeElement.value = '';
            this.pin3.nativeElement.value = '';
            this.pin4.nativeElement.value = '';
            this.pin5.nativeElement.value = '';
            this.pin6.nativeElement.value = '';

            this.pinEnvoye = {};
            this.changed(this.pin1.nativeElement);
        }
    }

    ngAfterViewInit() {
        setTimeout(() => this.pin1.nativeElement.focus());
        this.cdr.detectChanges();
    }

    confirmer() {

        let codepin = this.pin1.nativeElement.value;
        codepin += this.pin2.nativeElement.value;
        codepin += this.pin3.nativeElement.value;
        codepin += this.pin4.nativeElement.value;
        codepin += this.pin5.nativeElement.value;
        codepin += this.pin6.nativeElement.value;

        this.debloquer.emit(codepin);
    }


    changed(el = undefined) {
        if (el) {

            el.focus();
            if (el.id == 'kt_login_signin_submit') {
                setTimeout(() => this.btn.nativeElement.focus(), 0);
            }
        }

        if (
            this.pin1.nativeElement.value == '' ||
            this.pin2.nativeElement.value == '' ||
            this.pin3.nativeElement.value == '' ||
            this.pin4.nativeElement.value == '' ||
            this.pin5.nativeElement.value == '' ||
            this.pin6.nativeElement.value == ''
        ) {
            this.notValide = true;
        } else {
            this.notValide = false;
        }
    }


    onPaste(event: ClipboardEvent) {
        let clipboardData = event.clipboardData;
        let pastedText = clipboardData.getData('text');
        pastedText = pastedText.replace(/ /g, '');

        for (let i = 0; i < 6; i++) {
            switch (i) {
                case 0 :
                    this.pin1.nativeElement.value = pastedText.charAt(i);
                    break;

                case 1 :
                    this.pin2.nativeElement.value = pastedText.charAt(i);
                    break;

                case 2 :
                    this.pin3.nativeElement.value = pastedText.charAt(i);
                    break;

                case 3 :
                    this.pin4.nativeElement.value = pastedText.charAt(i);
                    break;

                case 4 :
                    this.pin5.nativeElement.value = pastedText.charAt(i);
                    break;

                case 5 :
                    this.pin6.nativeElement.value = pastedText.charAt(i);
                    break;
            }

        }

        this.changed();
        return false;
    }


    renvoyerPin() {
        this.pinEnvoye = {};
        this.pinLoading = true;
        this.authService.renvoyerPin(this.email).subscribe(
            (_data: string) => {
                if (_data) {
                    if (_data == '1') {
                        this.pinEnvoye.ok = true;
                        this.pinEnvoye.message = 'Le code de sécurité a été bien envoyé à votre adresse : ' + this.email;
                    } else {
                        this.pinEnvoye.ok = false;
                        this.pinEnvoye.message = 'Une erreur est survenue pendant le processus de soumission';
                    }
                    this.pinLoading = false;
                    this.cdr.detectChanges();
                }
            }
        );
    }

}
